export default {
  accountSettings: 'mdi mdi-account-cog',
  add: 'mdi-plus',
  alert: 'mdi-alert-outline',
  arrowLeft: 'mdi-arrow-left-thin',
  arrowRight: 'mdi-arrow-right-thin',

  check: 'mdi-check',
  close: 'mdi-close',
  company: 'mdi-office-building-cog',
  creditCards: 'mdi-credit-card-search',

  dashboard: 'mdi-view-dashboard-outline',
  delete: 'mdi-trash-can-outline',
  download: 'mdi-download',
  duplicate: 'mdi-content-copy',

  // edit: 'mdi-pencil',
  edit: 'mdi-pencil-box-outline',
  error: 'mdi-close-circle-outline',

  filter_list: 'mdi-filter',

  header: 'mdi-text-short',
  info: 'mdi-information',

  list: 'mdi-dots-vertical-circle-outline',

  media: 'mdi-image-album',
  modules: 'mdi-view-module',

  'non-visibility': 'mdi-eye-off',

  package: 'mdi-package',
  permission: 'mdi-account-arrow-right',
  product: 'mdi-dropbox',

  restore: 'mdi-file-restore',
  role: 'mdi-account-key',

  submodule: 'mdi-file-tree',
  success: 'mdi-check-circle-outline',
  support: 'mdi-lifebuoy',

  trash: 'mdi-delete',

  // userAdd: 'fa-user-plus',
  userAdd: 'mdi-account-edit',
  users: 'mdi:mdi-account-multiple',

  visibility: 'mdi-eye',
  warning: 'mdi-alert-circle-outline'
}
/** DEFAULT VUETIFY ICONS
$calendar	mdi-calendar
$cancel	mdi-close-circle
$checkboxIndeterminate	mdi-minus-box
$checkboxOff	mdi-checkbox-blank-outline
$checkboxOn	mdi-checkbox-marked
$clear	mdi-close-circle
$close	mdi-close
$collapse	mdi-chevron-up
$complete	mdi-check
$delete	mdi-close-circle
$delimiter	mdi-circle
$dropdown	mdi-menu-down
$edit	mdi-pencil
$error	mdi-close-circle
$expand	mdi-chevron-down
$eyeDropper	mdi-eyedropper
$file	mdi-paperclip
$first	mdi-page-first
$info	mdi-information
$last	mdi-page-last
$loading	mdi-cached
$menu	mdi-menu
$minus	mdi-minus
$next	mdi-chevron-right
$plus	mdi-plus
$prev	mdi-chevron-left
$radioOff	mdi-radiobox-blank
$radioOn	mdi-radiobox-marked
$ratingEmpty	mdi-star-outline
$ratingFull	mdi-star
$ratingHalf	mdi-star-half-full
$sortAsc	mdi-arrow-up
$sortDesc	mdi-arrow-down
$subgroup	mdi-menu-down
$success	mdi-check-circle
$treeviewCollapse	mdi-menu-down
$treeviewExpand	mdi-menu-right
$unfold	mdi-unfold-more-horizontal
$warning	mdi-alert-circle
 */
